import { api } from "./api";

/**
 * Thin API wrapper for the Anon Mode toggle.
 *
 * Anon Mode flips a server-side flag on the user doc. While active, every
 * new thread/comment the user authors gets stored with `is_anon: true` and
 * a random themed alias (e.g. GHOST_PROTOCOL_47). Existing posts are NEVER
 * rewritten — only posts made between enter() and exit() get disguised.
 */
export async function getAnonMode() {
  const { data } = await api.get("/me/anon-mode");
  return data; // { active: bool, alias: string | null }
}

export async function enterAnonMode() {
  // Server generates a fresh alias on every enter — different every time.
  const { data } = await api.post("/me/anon-mode/enter");
  return data;
}

export async function exitAnonMode() {
  const { data } = await api.post("/me/anon-mode/exit");
  return data;
}
